// extracted by mini-css-extract-plugin
export var callCard = "_qa-0";
export var callMessageButton = "_qa-1";
export var helpIcon = "_qa-3";
export var helpIconContainer = "_qa-4";
export var verticalDivider = "_qa-2";